// Copyright © 2025 Neosocios - Seguimiento De Conversiones

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    initializeTracking();
  }, 2000);

  function initializeTracking() {
    const urlParams = getUrlParams();
    const fbCookies = getFacebookCookies();
    const tkCookies = getTiktokCookies();
    const updateToken = getCookie("tracking_updated");

    if (
      (hasValidParams(urlParams) ||
        hasValidFbCookies(fbCookies) ||
        hasValidTkCookies(tkCookies)) &&
      updateToken !== "true"
    ) {
      updateCartWithTracking(urlParams, fbCookies, tkCookies);
    }
  }

  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      neose: params.get("neose"),
      neomm: params.get("neomm"),
      neocn: params.get("neocn"),
      neotm: params.get("neotm"),
      neoct: params.get("neoct"),
    };
  }

  function getFacebookCookies() {
    return {
      _fbc: getCookie("_fbc"),
      _fbp: getCookie("_fbp"),
    };
  }

  function getTiktokCookies() {
    return {
      _ttp: getCookie("_ttp"),
      ttclid: getCookie("ttclid"),
    };
  }

  function getCookie(name) {
    const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
    for (let cookie of cookies) {
      if (cookie.startsWith(name + "=")) {
        return decodeURIComponent(cookie.substring(name.length + 1));
      }
    }
    return null;
  }

  function setCookie(name, value, hours = 24) {
    const expires = new Date();
    expires.setTime(expires.getTime() + hours * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; Secure; SameSite=Lax`;
  }

  function hasValidParams(params) {
    return Object.values(params).some(
      (value) => value !== null && value !== ""
    );
  }

  function hasValidFbCookies(cookies) {
    return cookies._fbc || cookies._fbp;
  }

  function hasValidTkCookies(cookies) {
    return cookies._ttp || cookies.ttclid;
  }

  async function getCart() {
    try {
      const response = await fetch("/cart.js");
      if (!response.ok) throw new Error("Error obteniendo carrito");
      return await response.json();
    } catch (error) {
      console.error("Error al obtener carrito:", error);
      throw error;
    }
  }

  async function updateCartAttributes(attributes) {
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ attributes }),
      });

      if (!response.ok)
        throw new Error("Error actualizando atributos del carrito");
      return await response.json();
    } catch (error) {
      console.error("Error al actualizar atributos:", error);
      throw error;
    }
  }

  function buildTrackingAttributes(
    urlParams,
    fbCookies,
    tkCookies,
    existingAttributes = {}
  ) {
    const trackingAttributes = { ...existingAttributes };

    const paramMapping = {
      neose: "Source",
      neomm: "Medium",
      neocn: "Campaign",
      neotm: "Term",
      neoct: "Content",
    };

    Object.entries(paramMapping).forEach(([param, attribute]) => {
      if (urlParams[param]) {
        trackingAttributes[attribute] = urlParams[param];
      }
    });

    // Facebook
    if (fbCookies._fbc) {
      trackingAttributes["fbc"] = fbCookies._fbc;
    }
    if (fbCookies._fbp) {
      trackingAttributes["fbp"] = fbCookies._fbp;
    }

    // TikTok
    if (tkCookies._ttp) {
      trackingAttributes["ttp"] = tkCookies._ttp;
    }
    if (tkCookies.ttclid) {
      trackingAttributes["ttclid"] = tkCookies.ttclid;
    }

    return trackingAttributes;
  }

  function cleanCartAttributes(currentAttributes) {
    const allowedAttributes = [
      "Source",
      "Medium",
      "Campaign",
      "Term",
      "Content",
      "fbc",
      "fbp",
      "ttp",
      "ttclid",
    ];
    const cleanedAttributes = {};

    allowedAttributes.forEach((attr) => {
      if (currentAttributes[attr]) {
        cleanedAttributes[attr] = currentAttributes[attr];
      }
    });

    return cleanedAttributes;
  }

  async function updateCartWithTracking(urlParams, fbCookies, tkCookies) {
    try {
      const cart = await getCart();
      const currentAttributes = cart.attributes || {};

      const cleanedAttributes = cleanCartAttributes(currentAttributes);

      const updatedAttributes = buildTrackingAttributes(
        urlParams,
        fbCookies,
        tkCookies,
        cleanedAttributes
      );

      const hasChanges =
        JSON.stringify(currentAttributes) !== JSON.stringify(updatedAttributes);

      if (hasChanges) {
        await updateCartAttributes(updatedAttributes);
        setCookie("tracking_updated", "true", 1);
        console.log("Atributos de tracking actualizados:", updatedAttributes);
      } else {
        console.log("No hay cambios en los atributos de tracking");
      }
    } catch (error) {
      console.error("Error en el proceso de tracking:", error);
    }
  }
});